<div fxHide.gt-sm>
  <mat-toolbar>
    <div fxLayout="row" fxLayoutAlign="space-around center">
      <button
        mat-icon-button
        aria-label="Open navigation menu"
        (click)="onToggle()"
      >
        <mat-icon>menu</mat-icon>
      </button>
      <img class="logo" [src]="logoUrl" [attr.alt]="tenantName + ' logo'" />
    </div>
    <div fxFlex fxLayout fxLayoutAlign="end">
      <button
        mat-button
        [matMenuTriggerFor]="menu"
        [attr.aria-label]="'Account menu for ' + userName"
      >
        {{ userName }}
        <mat-icon iconPositionEnd>expand_more</mat-icon>
      </button>
      <mat-menu #menu="matMenu">
        <button mat-menu-item (click)="changePassword()">
          <mat-icon>vpn_key</mat-icon>
          <span>Change Password</span>
        </button>

        <button mat-menu-item (click)="logout()">
          <mat-icon>exit_to_app</mat-icon>
          <span>Log out</span>
        </button>
      </mat-menu>
    </div>
  </mat-toolbar>
</div>
